<template>
  <div class="px-4 pb-5">
    <div class="d-flex justify-center align-center flex-column">
      <h3
        style="font-weight: 500"
      >
        {{ title() }}
      </h3>
      <div class="d-flex justify-center pb-5">
        <div v-if="group && group.id" class="mr-3">
          <span
            class="small-title mr-1"
          >
            ID
          </span>
          <span
            class="small-text"
          >
            {{ group.id }}
          </span>
        </div>
        <div>
          <span
            class="small-title mr-1"
          >
            Organisation
          </span>
          <span
            class="small-text"
          >
            {{ organization.name }}
          </span>
        </div>
      </div>
    </div>
    <v-text-field
      dense
      v-model="name"
      label="Nom du groupe"
      :rules="rulesName"
    />
    <v-text-field
      dense
      class="mt-3"
      v-model="description"
      label="Description"
    />
    <v-autocomplete
      label="Users"
      v-model="users"
      clearable
      multiple
      :items="organization.users"
    >
      <template v-slot:item="item">
        <div>
          {{ item.item.firstName }} {{ item.item.lastName }}
        </div>
      </template>
      <template v-slot:selection="selection">
        <v-chip close @click:close="removeUser(selection.index)">
          {{ selection.item.firstName }} {{ selection.item.lastName }}
        </v-chip>
      </template>
    </v-autocomplete>
    <!--
      <v-switch
        v-model="isPrivate"
        label="Groupe privé"
      />
    -->
    <div class="pt-2 d-flex justify-space-between">
      <DeleteDialog
        v-if="group && group.id"
        title="Supprimer le groupe"
        :entity-id="group.id"
        :entity-name="group.name"
        @deleted="deleteGroup"
      />
      <div v-else /> <!-- For justify-space-between -->
      <v-btn
        outlined
        color="primary"
        @click.stop="onSave"
        :disabled="!validForm()"
      >
        Sauvegarder
      </v-btn>
    </div>
  </div>
</template>
<script>
import { GroupService } from './GroupService';
import DeleteDialog from './DeleteDialog';
import { OrganizationService } from './OrganizationService';

export default {
  name: 'GroupForm',
  components: { DeleteDialog },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      name: this.group ? this.group.name : '',
      description: this.group ? this.group.description : '',
      isPrivate: this.group ? this.group.isPrivate : true,
      rulesName: [this.validName],
      selection: undefined,
      users: [],
    };
  },
  methods: {
    title() {
      if (this.isNewGroup()) {
        return "Création d'un nouveau groupe";
      }
      return 'Paramètres de groupe';
    },
    validName(name) {
      if (!name) return false;

      return name.length >= 1;
    },
    validForm() {
      return this.validName(this.name);
    },
    async onSave() {
      if (this.isNewGroup()) {
        await this.groupService.createGroupInOrganization(this.organization.id, {
          name: this.name,
          isPrivate: this.isPrivate,
          description: this.description,
          userIds: this.users.map(user => user.id),
        });
      } else {
        await this.groupService.updateGroupInOrganization(this.organization.id, this.group.id, {
          name: this.name,
          isPrivate: this.isPrivate,
          description: this.description,
          userIds: this.users.map(user => user.id),
        });
      }
      this.$emit('saved');
    },
    async deleteGroup() {
      const organizationService = new OrganizationService();
      await organizationService.deleteGroupFromOrganization(this.organization.id, this.group.id);
      this.$emit('saved');
    },
    isNewGroup() {
      return !(this.group && this.group.id);
    },
    async removeUser(index) {
      this.users.splice(index, 1);
    },
  },
  created() {
    this.groupService = new GroupService();

    if (this.group && this.group.userIds) {
      this.users = this.organization.users.filter(user => this.group.userIds.includes(user.id));
    }
  },
};
</script>
<style scoped>
.small-title {
  font-size: 12px;
  font-weight: 500;
  color: rgba(100, 100, 100, 1);
}
.small-text {
  font-size: 10px;
  font-weight: 350;
  color: rgba(100, 100, 100, 1);
}
.danger-zone {
  font-size: 16px;
  font-weight: 600;
  color: red;
}
.delete-title {
  font-size: 24px;
  font-weight: 500;
  color: black;
}
.delete-font-title {
  font-size: 16px;
  font-weight: 600;
  color: black;
}
.delete-font-content {
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  color: black;
}
.danger-warning {
  color: #e07e21;
}
</style>
